export default "__VITE_ASSET__yZOkj3M2__"